export const isBillingError = errorCode => {
  const billingErrorCodes = [
    'BL_803.9',
    'BL_800.7',
    'BL_803.2',
    'BL_801.22',
    'BL_801.23',
    'BL_801.24',
    'BL_801.25',
    'BL_801.26',
    'BL_801.27',
    'BL_801.28',
    'BL_801.29',
    'BL_801.30',
    'BL_801.31',
    'BL_801.32',
    'BL_801.33',
    'BL_801.34',
    'BL_801.45',
    'BL_801.46',
    'BL_801.49',
    'BL_801.53',
    'BL_803.24',
    'SC_1072',
  ];

  return billingErrorCodes.includes(errorCode);
};
